import React from 'react';

import NewUserForm from './NewUserForm';
import ReturningUserForm from './ReturningUserForm';

import './AccountStyle.less';

const renderForm = props => {
  const { existingUser } = props;

  return existingUser ? <ReturningUserForm {...props} /> : <NewUserForm {...props} />;
};

export default props => {
  return (
    <div className="od-offer-flow-account">
      <section id="sign-up">
        <div className="row center-xs">
          <div className="col-xs-10">{renderForm(props)}</div>
        </div>
      </section>
    </div>
  );
};
